import React, {useState, useEffect} from 'react'
import {useFirestore, useFirebase} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as StructureActions from '../../../actions/canvas/StructureActions';
import {OutcomeRow} from './outcomerow';
import { Table, Form, Button, Icon, Dropdown } from 'semantic-ui-react'
import _ from 'lodash';

export function Markettype(props){
    const firestore = useFirestore();
    const firebase = useFirebase();
    const dispatch = useDispatch();

    let outcomes = {};
    Object.values(props.outcomes).forEach((outcome) => {
        outcomes[outcome.canvas.code] = outcome;
    });
    outcomes = Object.values(outcomes);

    outcomes.sort((a, b) => parseInt(a.canvas.code) - parseInt(b.canvas.code));

    const [markettype, setMarkettype] = useState(null);

    useEffect(() => {
        setMarkettype(props.type);
    }, [props.type]);

    
    if(markettype === null)return null;

    let name = (typeof markettype.name !== 'undefined')
                        ?markettype.name
                        :'';

    const setMappings = (outcomeId, mappings) => {
        let copy = _.cloneDeep(markettype);
        copy.changed = true;

        if(mappings === null && typeof copy.mappings !== 'undefined' && typeof copy.mappings[outcomeId] !== 'undefined')
            delete copy.mappings[outcomeId];
        if(mappings !== null){
            if(typeof copy.mappings === 'undefined')
                copy.mappings = {};

            copy.mappings[outcomeId] = _.cloneDeep(mappings);
        }

        setMarkettype(copy);
    }

    const setName = (name) => {
        let copy = _.cloneDeep(markettype);
        copy.changed = true;
        copy.name = name;
        setMarkettype(copy);
    }

    const setUid = (typeid) => {
        let copy = _.cloneDeep(markettype);
        copy.changed = true;
        copy.typeid = typeid;
        setMarkettype(copy);
    }

    const setConstraint = (constraint) => {
        let copy = _.cloneDeep(markettype);
        copy.changed = true;
        if(constraint === '-'){
            if(typeof copy.constraint !== 'undefined')
                delete copy.constraint;
        }else copy.constraint = constraint;
        setMarkettype(copy);
    }

    const constraintOptions = [
        {
            key: '-',
            text: 'Constraints des Events verwenden (standard)',
            value: '-'
        },
        {
            key: 'nc',
            text: 'Keine Constraints ausgeben',
            value: 'nc'
        },
        {
            key: '*',
            text: '*: Beliebiges Event/Markt',
            value: '*'
        },
        {
            key: 'powerplay',
            text: 'Powerplay',
            value: 'powerplay'
        },
        {
            key: 'cc+1',
            text: 'cc+1',
            value: 'cc+1'
        },
        {
            key: 'cc+2',
            text: 'cc+2',
            value: 'cc+2'
        }
    ];

    return (
        <div style={{
            margin: '1em'
        }}>
            <Form>
                <h1>Einstellung für alle Märkte vom Typ "{markettype.uid}"</h1>
                <Form.Input label="Bezeichnung" placeholder="Bezeichnung oder leer lassen, um den Wert automatisch zu übernehmen" value={name} onChange={(e) => setName(e.target.value)} />
                <Form.Input label="Typ-ID" placeholder="ID des Markttyps" value={(typeof markettype.typeid === 'undefined')?'':markettype.typeid} onChange={(e) => setUid(e.target.value)} />
                <Dropdown label="Constraints" fluid selection placeholder="Welche Constraints sollen für diesen Markttyp verwendet werden?" options={constraintOptions} value={(typeof markettype.constraint === 'undefined')?'-':markettype.constraint} onChange={(e, {value}) => {
                    setConstraint(value);
                }} />
                <div style={{
                    marginTop: '0.5em'
                }}>
                    <Button><Icon name="filter" /> Constraint-Filter bearbeiten</Button>
                </div>
            </Form>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Canvas-ID</Table.HeaderCell>
                        <Table.HeaderCell>Art</Table.HeaderCell>
                        <Table.HeaderCell>Clean</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Alternativ-Namen</Table.HeaderCell>
                        <Table.HeaderCell>Handicap</Table.HeaderCell>
                        <Table.HeaderCell>Markt</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                {
                    (_.filter(outcomes, (outcome) => (typeof outcome.canvas.code !== 'undefined' && outcome.canvas.code !== ''))).map((outcome) => <OutcomeRow showUid={false} onMappingsChanged={(mappings) => setMappings(outcome.canvas.code, mappings)} key={outcome.uid} outcome={outcome} market={markettype} />)
                }
                </Table.Body>
            </Table>
            <div style={{
                display: 'flex'
            }}>
                <div>
                    <Button icon labelPosition="left" onClick={(e) => {
                        dispatch(RouterActions.push('/canvas/markets/' + props.channel + '/' + props.sport))
                    }}><Icon name="left arrow" />Zurück zur Übersicht</Button>
                </div>
                <div style={{
                    flexGrow: 1
                }}>
                    <Button icon labelPosition="left" onClick={(e) => {
                        let relevantFields = _.pick(markettype, ['mappings', 'name', 'constraint', 'typeid']);
                        if(typeof relevantFields.name !== 'undefined' && (relevantFields.name === null || relevantFields.name.length === 0))
                            delete relevantFields.name;
                        if(typeof relevantFields.typeid !== 'undefined' && (relevantFields.typeid === null || relevantFields.typeid.length === 0))
                            delete relevantFields.typeid;
                        relevantFields.sport_uid = props.sport;

                        dispatch(StructureActions.save(firebase, props.channel, 'markettype', markettype.uid, relevantFields))
                    }} fluid disabled={(typeof markettype.changed === 'undefined' || !markettype.changed)} primary><Icon name="save" />Änderungen speichern</Button>
                </div>
            </div>
        </div>
    );
}